import React from "react";
import logo from "../img/official_logo.svg";
import { Link } from "react-router-dom";
import SearchBox from "./SearchBox";
import FiltersBox from "./FiltersBox";
import TabBar from "./TabBar";
import {Navbar, Image, Nav} from "react-bootstrap";
import SettingsMenu from "./menus/SettingsMenu";
import UserMenu from "./menus/UserMenu";
import InfoMenu from "./menus/InfoMenu";
import ExportMenu from "./menus/ExportMenu";
import {withPropsChecker} from "../lib/utils";
import UISwitch from "./UISwitch";

const NavBar = props => {
  const {searchSessionStore: {clear: clearSearch, hasActiveUncachedSearch}, settings = {}} = props;

  const handleLogoClick = (e) => {
    // Don't navigate if a dropdown menu is open - let it close first
    if (document.querySelector('.dropdown-menu.show')) {
      e.preventDefault();
      return false;
    }
    // clearSearch() runs synchronously here, ahead of the router's own navigation-away
    // guard (App.js's useBlocker), so an active/in-flight search (not yet safe to cache —
    // see PLEX-6054) must be confirmed here too, or it would be silently discarded before
    // the blocker ever gets a chance to intervene.
    if (hasActiveUncachedSearch
        && !window.confirm("A search is still in progress. Leaving will stop it and you may lose live updates. Continue?")) {
      e.preventDefault();
      return false;
    }
    clearSearch();
  };

  return (
    <Navbar collapseOnSelect className={props.className}>
      <div className="navbar-controls container-fluid">
        <Navbar.Brand>
          <Link tabIndex={0} to="/" onClick={handleLogoClick}>
            <Image src={logo} className="navbar-logo" />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle data-bs-target="navbar-menus"/>
        <Navbar.Collapse>
          <Nav className="navbar-searchbox navbar-form me-auto" tabIndex={1}>
            <SearchBox />
          </Nav>
          <Nav id="navbar-menus" className="navbar-menus ms-auto">
            <Link className="navbar-logo-mini" to="/" onClick={handleLogoClick}>
              <Image src={logo} className="navbar-logo-mini" />
            </Link>
            <div className="client-logo" />
            {/* Always visible for now; swap to per-user v2-access gating once that entitlement exists */}
            <UISwitch current="v1" />
            <ExportMenu />
            <UserMenu />
            <SettingsMenu {...settings} />
            <InfoMenu />
          </Nav>
        </Navbar.Collapse>
      </div>
      <Nav className="navbar-footer" >
        <FiltersBox />
        <TabBar {...props} />
      </Nav>
    </Navbar>
  );
};

export default NavBar;
